// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-button__container {
  position: relative;
  display: flex;
  align-items: center;
}

.menu-button {
  background: transparent;
  border: none;
  display: flex;
  cursor: pointer;
  justify-content: center;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
}
.menu-button.light, .menu-button.light-btn {
  width: 20px;
  height: 20px;
  padding: 0;
}
.menu-button.light:not(:disabled):focus, .menu-button.light:not(:disabled):hover, .menu-button.light:not(:disabled):active, .menu-button.light-btn:not(:disabled):focus, .menu-button.light-btn:not(:disabled):hover, .menu-button.light-btn:not(:disabled):active {
  background-color: var(--white-hover-color);
}
.menu-button.light.visible, .menu-button.light-btn.visible {
  background-color: var(--white-active-color);
}
.menu-button.light .menu-img > path, .menu-button.light-btn .menu-img > path {
  fill: var(--secondary-text-color);
}
.menu-button.dark {
  gap: 4px;
  align-items: center;
  background-color: var(--primary-light-color);
  padding: 8px 8px 8px 12px;
  color: var(--white-color);
}
.menu-button.dark:focus, .menu-button.dark:hover {
  background-color: var(--primary-light-hover-color);
}
.menu-button.dark:active {
  background-color: var(--primary-light-active-color);
}
.menu-button.dark.visible {
  background-color: var(--primary-light-selected-color);
}
.menu-button.dark .kebab-img > path {
  stroke: var(--white-color);
}
.menu-button:disabled {
  cursor: default;
}

.popup-menu__container {
  position: fixed;
  display: flex;
  left: 0;
  top: 0;
  height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  min-height: 36px;
  background: var(--web-primary-color);
  box-shadow: 6px 0 16px 0 rgba(0, 0, 0, 0.19);
  border-radius: 4px;
  z-index: 12;
  touch-action: none;
}`, "",{"version":3,"sources":["webpack://./src/components/MenuButton/MenuButton.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EAEC,gBAAA;EACA,eAAA;EACA,iBAAA;AAAH;AAEE;EAEE,WAAA;EACA,YAAA;EACA,UAAA;AADJ;AAGI;EACE,0CAAA;AADN;AAII;EACE,2CAAA;AAFN;AAKI;EACE,iCAAA;AAHN;AAOE;EACE,QAAA;EACA,mBAAA;EACA,4CAAA;EACA,yBAAA;EACA,yBAAA;AALJ;AAOI;EACE,kDAAA;AALN;AAQI;EACA,mDAAA;AANJ;AASI;EACE,qDAAA;AAPN;AAUI;EACE,0BAAA;AARN;AAYE;EACE,eAAA;AAVJ;;AAgBA;EACE,eAAA;EACA,aAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,oCAAA;EACA,4CAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAbF","sourcesContent":[".menu-button__container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.menu-button {\n  background: transparent;\n  border: none;\n  display: flex;\n  cursor: pointer;\n  justify-content: center;\n  border-radius: 4px;\n\n   font-weight: 700;\n   font-size: 12px;\n   line-height: 15px;\n\n  &.light,\n  &.light-btn {\n    width: 20px;\n    height: 20px;\n    padding: 0;\n\n    &:not(:disabled):focus, &:not(:disabled):hover, &:not(:disabled):active {\n      background-color: var(--white-hover-color)\n    }\n\n    &.visible {\n      background-color: var(--white-active-color);\n    }\n\n    .menu-img > path {\n      fill: var(--secondary-text-color);\n    }\n  }\n\n  &.dark {\n    gap: 4px;\n    align-items: center;\n    background-color: var(--primary-light-color);\n    padding: 8px 8px 8px 12px;\n    color: var(--white-color);\n\n    &:focus, &:hover {\n      background-color: var(--primary-light-hover-color);\n    }\n\n    &:active {\n    background-color:  var(--primary-light-active-color);\n    }\n\n    &.visible {\n      background-color: var(--primary-light-selected-color);\n    }\n\n    .kebab-img > path {\n      stroke: var(--white-color);\n    }\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n\n}\n\n\n.popup-menu__container {\n  position: fixed;\n  display: flex;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 36px;\n  background: var(--web-primary-color);\n  box-shadow: 6px 0 16px 0 rgba(0, 0, 0, 0.19);\n  border-radius: 4px;\n  z-index: 12;\n  touch-action: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
